import { useState } from "react";

const MESSAGE =
  "Stay safe: Please make payments only through the official SalaryMates website. If any executive or other person asks you to pay into their personal account, do not pay — report it to us immediately at support@salarymates.com. You are responsible for any payment made to an unauthorized personal account.";

export default function FraudAwarenessBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#7A1E1E] text-white shadow-[0_-2px_8px_rgba(0,0,0,0.2)] flex items-center h-8">
      <style>{`
        @keyframes fraudBannerMarquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
      <div className="flex-1 overflow-hidden">
        <div
          className="flex w-max whitespace-nowrap text-xs"
          style={{ animation: "fraudBannerMarquee 28s linear infinite" }}
        >
          <span className="px-8">{MESSAGE}</span>
          <span className="px-8" aria-hidden="true">
            {MESSAGE}
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss safety notice"
        className="shrink-0 bg-transparent border-0 text-white/80 hover:text-white text-base leading-none px-2"
      >
        ×
      </button>
    </div>
  );
}
